export default __webpack_public_path__ + "static/media/richtext.6b97c499.svg";